import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { FaShieldAlt } from 'react-icons/fa';
import { useColorMode } from './color-mode';

export default function PageLoader({ minH = '60vh' }) {
  const { colorMode } = useColorMode();
  const dark = colorMode === 'dark';

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={minH}
      gap={5}
    >
      <Box position="relative" w="56px" h="56px" display="flex" alignItems="center" justifyContent="center">
        {/* Ripple ring 1 */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          w="56px"
          h="56px"
          borderRadius="full"
          border="2px solid"
          borderColor={dark ? 'brand.600' : 'brand.300'}
          style={{ animation: 'eg-ripple 2s ease-out infinite', transform: 'translate(-50%, -50%)' }}
        />
        {/* Ripple ring 2 (offset) */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          w="56px"
          h="56px"
          borderRadius="full"
          border="2px solid"
          borderColor={dark ? 'brand.600' : 'brand.300'}
          style={{ animation: 'eg-ripple 2s ease-out infinite 0.7s', transform: 'translate(-50%, -50%)' }}
        />
        {/* Shield icon */}
        <Box
          color={dark ? 'brand.300' : 'brand.600'}
          fontSize="30px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ animation: 'eg-shield-pulse 2s ease-in-out infinite' }}
        >
          <FaShieldAlt />
        </Box>
      </Box>

      <Text
        fontFamily="'Play', sans-serif"
        fontSize="sm"
        fontWeight="700"
        letterSpacing="-0.5px"
        color={dark ? 'brand.200' : 'brand.700'}
      >
        examgate
        <Text as="span" color={dark ? 'accent.400' : 'accent.600'}>.net</Text>
      </Text>
    </Box>
  );
}
